import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";

const cargoWiseSettingsStyle = makeStyles({
  cargoWiseSettings: {
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "32px",
    position: "relative",
    background: colors.white,

    "& .cw-badge": {
      position: "absolute",
      top: "-10px",
      left: "20px",
      fontSize: "12px",
      fontWeight: 600,
      padding: "4px 10px",
      borderRadius: "6px",
      background: "#e7f0ff",
      color: colors.primary,
    },

    "& .cw-title": {
      fontSize: "18px",
      fontWeight: 600,
      marginBottom: "8px",
    },

    "& .cw-desc": {
      fontSize: "14px",
      color: "#6b7280",
      marginBottom: "24px",
    },

    "& .cw-form": {
      display: "flex",
      alignItems: "flex-end",
      gap: "16px",
    },

    "& .cw-input": {
      flex: 1,
      maxWidth: "700px",
      fontSize: "14px",
      "& .cw-input-email .MuiInputBase-input.MuiInput-input": {
        border: "none"
      }
    },

    "& .cw-chip-list": {
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      width: "100%",
    },

    "& .cw-chip": {
      fontSize: "14px",
      border: "none",
      background: "#e5e4e4",
      borderRadius: "30px",
      height: "28px",
      lineHeight: "28px",
      margin: "0 8px 8px 0",
      justifyContent: "space-between",
      width: "fit-content",
    },
  },
  customModal: {
    "& .MuiDialog-paperWidthSm": {
      boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.24)",
      padding: "40px",
      textAlign: "center",
      maxWidth: "500px",
      width: "100%",
      "@media(max-width:767px)": {
        width: "auto",
        maxWidth: "100%",
        padding: "25px 15px",
        margin: "0 15px",
      },
      "& .MuiDialogContent-root,& .MuiDialogActions-root, & .MuiDialogTitle-root": {
        padding: "0",
        justifyContent: "space-between",
      },
      "& .MuiDialogTitle-root": {
        "& .MuiTypography-root": {
          fontWeight: "700",
          fontSize: "24px",
          lineHeight: "1.321",
          color: colors.black,
          marginBottom: "12px",
          "& img": {
            display: "block",
            margin: "0 auto 20px",
          },
        },
      },
      "& .MuiDialogContent-root": {
        "& .MuiTypography-root": {
          fontWeight: "400",
          fontSize: "18px",
          lineHeight: "1.44",
          color: colors.black,
          margin: "0 auto 30px",
        },
        "& .MuiTypography-gutterBottom": {
          margin: "0"
        },
      },
      "& .MuiDialogActions-root": {
        "@media(max-width:374px)": {
          flexWrap: "wrap",
        },
        "& button": {
          maxWidth: "165px",
          width: "100%",
          height: "50px",
          lineHeight: "50px",
          fontSize: "16px",
          fontWeight: "600",
          textTransform: "uppercase",
          "@media(max-width:374px)": {
            maxWidth: "100%",
            flex: "0 0 100%",
          },
        },
        "& button + button": {
          marginLeft: "20px",
          "@media(max-width:767px)": {
            marginLeft: "15px",
          },
          "@media(max-width:374px)": {
            margin: "15px 0 0",
          },
        },
      },
    },
  },
});

export { cargoWiseSettingsStyle };
